/**
 * 유틸
 * @category common
 * @example
 * import Utils from '../common/Utils';
 * Utils.namespace('nc.lineage2.sampleApp');
*/
class Utils {
    constructor(){}

    /**
     * namespace 를 확인후 해당 네임스페이스가 없을 경우 만들어서 리턴
     * @param  {} _namespace='window.console'
     * @param  {} _parent=window
     * @returns {Object}
     * @example
     * Utils.namespace('nc.lineage2.sampleApp');
     * var testApp = new nc.lineage2.sampleApp();
     */
    static namespace (_namespace = 'window.console', _parent = window) {
        if ( typeof _namespace === 'string' && _namespace ) {
            let parts = _namespace.split('.');
            for (let i = 0, max = parts.length; i < max; i++) {
                if (!_parent[parts[i]]) _parent[parts[i]] = {};
                _parent = _parent[parts[i]];
            }
        }
        return _parent;
    }

    /**
     * 객체가 유효한지 확인
     * @param  {Object} obj={} 탐색 대상 오브젝트
     * @param  {Array} keys=[] 키네임
     * @returns {Boolean}
     * @example
     * // window.Twitch.Player 객체가 유효한지 확인하는 샘플
     * Utils.objHasKeys( window, ['Twitch', 'Player'] )
     */
    static objHasKeys ( obj={}, keys=[]) {
        let next = keys.shift();
        return obj[next] && (! keys.length || this.objHasKeys(obj[next], keys));
    }

    /**
     * 쿠키 세팅
     * @param  {String} name 쿠키이름
     * @param  {String} value 쿠키값
     * @param  {Number} expiredays 만료날짜
     * 
     * @example
     * Utils.setCookie('topBanner', 'show', 1);
     */
    static setCookie( name='', value='', expiredays=1 ) {
        let todayDate = new Date();
        todayDate.setDate( todayDate.getDate() + expiredays );
        document.cookie = name + "=" + escape( value ) + "; path=/; domain=.plaync.com;expires=" + todayDate.toGMTString() + ";";
    }

    /**
     * 쿠키 확인
     * @param  {String} name 쿠키이름
     * @returns {String}
     * @example
     * Utils.getCookie('topBanner') == 'show' // true : 쿠키가 입력 되어 있는 상태
     */
    // [TODO] 고쳐야함!! Utils의 getCookie가 쿠키의 이름이 부분적으로만 일치해도 있는 것으로 나온다.
    static getCookie(name='') {
        let cookies = document.cookie;
        if(cookies.indexOf(name)==-1)return false;
        let cookie = cookies.substr(cookies.indexOf(name));
            cookie = cookie.split(';')[0];
            cookie = cookie.substr(cookie.indexOf('=')+1);
        return cookie;
    }

    /**
     * 숫자 앞에 0 붙여주기 ex) '01', '001'
     * @param  {Number} n
     * @param  {Number} digits
     * @returns {String}
     * @example
     * Utils.leadingZeros( 3, 2 ) // return '03'
     */
    static leadingZeros(n, digits) {
        let zero = '';
        const len = n.toString().length;
        let i = 0;
        if (len < digits) {
            for (; i < digits - len; i += 1) {
                zero += '0';
            }
        }
        return zero + n;
    }

    /**
     * URL 파라미터 키네임으로 값 가져오기
     * @param  {String} name 키네임
     * @param  {String} url 필수아님
     * @returns {String}
     * @example
     * Utils.getParamByName('query'); // return '검색어'
     * Utils.getParamByName('query', 'https://lineage.plaync.com/search/index?query=test'); // return 'test'
     */
    static getParamByName( name, url ) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
    
    /**
     * URL에 파라미터 추가하기
     * @param  {String} _key
     * @param  {String} _val
     * @param  {String} _url
     * @returns {String}
     * @example
     * Utils.addParam( 'page_no', '43' ),
     */
    static addParam(_key = 'key', _val = 0, _url = window.location.href){
        if(window.location.search){ //?파람이 있는 경우 
            if(Utils.getParamByName(_key)){ // 해당 키값이 이미 존개하는경우 

                let regex = new RegExp(_key + "(=([^&#]*)|&|#|$)");
                _url = _url.replace( regex, `${_key}=${_val}`);
            }else{ //해당 키값이 없는경우
                _url += `&${_key}=${_val}`;
            }
        }else{ //?파람이 없는 경우 
            _url += `?${_key}=${_val}`;
        }
        return _url;
    }


    static updateURLParameter(param, paramVal, url = window.location.href ){
        var newAdditionalURL = "";
        var tempArray = url.split("?");
        var baseURL = tempArray[0];
        var additionalURL = tempArray[1];
        var temp = "";
        if (additionalURL) {
            tempArray = additionalURL.split("&");
            for (var i=0; i<tempArray.length; i++){
                if(tempArray[i].split('=')[0] != param){
                    newAdditionalURL += temp + tempArray[i];
                    temp = "&";
                }
            }
        }
    
        var rows_txt = temp + "" + param + "=" + paramVal;
        return baseURL + "?" + newAdditionalURL + rows_txt;
    }

    /**
     * DateFormat 
     * @param  {String} _date
     * @returns {String}
     * @example
     * Utils.getDate(_d.date);
     */
    static getDate(_date = ''){
        return new Date(_date).toISOString().split('T')[0].replace(/\-/gi, '.') + '.';
    }

    /**
     * URL에 파라미터 삭제하기
     * @param  {String} _key
     * @param  {String} _url
     * @returns {String}
     * @example
     * Utils.removeParam( 'page_no'),
     */
    static removeParam(_key = 'key', _val='', _url = window.location.href){
        const param = Utils.getParamByName(_key);

        if(param){ //?파람이 있는 경우 
            const values = param.split(','); 
            if(values.length > 1){ // 값이 2개 이상일 경우 해당 값만 삭제
                _url =  _url.replace(param, values.filter( val => val !== _val).join(''))
            }else{ // 값이 하나일 경우 key도 삭제 
                _url = _url.split(`&${_key}=${_val}`).join('');
            }
        }
        return _url;
    }

    static removeParamKey(key){
        let host  = location.host;
        let path = location.pathname;
        let hash = location.hash;
        
        let searchParams = new URLSearchParams(location.search);

        searchParams.delete(key);

        let searchParamsStrs = searchParams.toString();
        console.log(searchParamsStrs);
        return searchParamsStrs;
    }
} // end of class
export default Utils;